import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/stores/auth.store";
import { t } from "@/components/ui";

export default function ProtectedRoute() {
  // Zustand persist rehydrates asynchronously. Wait one tick before
  // deciding the user is unauthenticated to avoid a false redirect.
  const [hydrated, setHydrated] = useState(false);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) {
    return (
      <div style={{ height: "100vh", background: t.bg, display: "flex", alignItems: "center", justifyContent: "center", color: t.muted }}>
        <div style={{
          width: 24, height: 24, borderRadius: "50%",
          border: `2px solid ${t.border}`, borderTopColor: t.accent,
          animation: "spin 0.6s linear infinite",
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}
